import styled from 'styled-components';

/**
 * 12×12 커스텀 체크 표시 입력. 실제 DOM `type`은 `checkbox`(기본) 또는 `radio`.
 * 라디오 그룹은 동일 `name`과 각각의 `value`/`checked`/`onChange`를 넘깁니다.
 */
export const UniversalCheckbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  width: 12px;
  height: 12px;
  border: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
  margin-right: 10px;
  outline: none;
  transition: border 0.2s, background 0.2s;
  position: relative;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.colors.color_Gray_03};
  }

  &:checked {
    border-color: ${({ theme }) => theme.colors.color_Gray_03};
  }

  &:checked::after {
    content: '';
    position: absolute;
    left: 4px;
    top: -3px;
    width: 5px;
    height: 10px;
    border: solid ${({ theme }) => theme.colors.color_Gray_02};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;
